import { corporateEntityMapper } from '@services/mappers';
import { CorporateEntityProfile } from '@typeDefs/domain/profile';
import apiClient from './client';

export const businessService = {
  async getProfile(id: string): Promise<CorporateEntityProfile> {
    const response = await apiClient.api.corporateEntitiesProfileDetail(id);
    const mappedItems = corporateEntityMapper.fromApi(response.data);
    return mappedItems;
  },
  // - updateProfile(businessId, profileData)
  // - getBusinessList()
  // - getBusinessUsers(businessId)
  // - updateBusinessSettings(businessId, settings)
};
